import { useEffect } from "react";
import { X, ArrowUpRight } from "lucide-react";

const ARModal = ({ experience, onClose }) => {
  useEffect(() => {
    if (!experience) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [experience, onClose]);

  if (!experience) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-neutral-950/90 flex flex-col" data-testid="ar-modal" onClick={onClose}>
      <div className="flex items-center justify-between px-6 py-4 text-white" onClick={(e) => e.stopPropagation()}>
        <p className="text-sm font-bold uppercase tracking-widest" data-testid="ar-modal-title">{experience.label}, Live Experience</p>
        <div className="flex items-center gap-5">
          <a
            href={experience.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ar-modal-open-tab"
            className="text-xs font-bold uppercase tracking-widest text-white/80 hover:text-brand-red transition-colors flex items-center gap-1"
          >
            Open in new tab <ArrowUpRight size={14} />
          </a>
          <button onClick={onClose} aria-label="Close experience" data-testid="ar-modal-close" className="p-1 hover:text-brand-red transition-colors">
            <X size={26} />
          </button>
        </div>
      </div>
      <div className="flex-1 px-4 pb-6 min-h-0" onClick={(e) => e.stopPropagation()}>
        <iframe src={experience.url} title={`${experience.label}, live AR`} className="w-full h-full bg-white border border-neutral-700" data-testid="ar-modal-iframe" />
      </div>
    </div>
  );
};

export default ARModal;
